/**
 * @generated SignedSource<<31c110acbff6c579950ce5bdefaca683>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useRestrictionDisplayName_bookingRestriction$data = {
  readonly displayName: string | null | undefined;
  readonly name: string;
  readonly " $fragmentType": "useRestrictionDisplayName_bookingRestriction";
};
export type useRestrictionDisplayName_bookingRestriction$key = {
  readonly " $data"?: useRestrictionDisplayName_bookingRestriction$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRestrictionDisplayName_bookingRestriction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRestrictionDisplayName_bookingRestriction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    }
  ],
  "type": "BookingRestriction",
  "abstractKey": "__isBookingRestriction"
};

(node as any).hash = "84293361a47377ee0a3c551da54dea66";

export default node;
